<script setup>
import { computed, onMounted } from 'vue'
import { getI18n } from '@/plugins/i18n'

import { useWebSiteStore } from '@/stores/web-site.store'

const props = defineProps({
  modelValue: {
    type: [Number, String, null],
    required: false,
    default: null,
  },
  label: {
    type: String,
    required: false,
    default: null,
  },
  clearable: {
    type: Boolean,
    required: false,
    default: false,
  },
  readonly: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const i18n = getI18n()
const webSiteStore = useWebSiteStore()

const options = computed(() => [...(webSiteStore.getLocalizedVatTypes() || [])].sort((a, b) => b.percentage - a.percentage))

onMounted(() => webSiteStore.fetchVatTypesAsync({ all: true }, true))
</script>
<template>
  <q-select
    :model-value="props.modelValue"
    :options="options"
    :label="label || i18n.t('common.vat')"
    option-value="id"
    option-label="name"
    emit-value
    map-options
    :clearable="props.clearable"
    :readonly="props.readonly"
    @update:model-value="(val) => emit('update:modelValue', val)"
  />
</template>
